import { render, staticRenderFns } from "./GeneralSettingsDateFormatConsole.vue?vue&type=template&id=23f80cd6&"
import script from "./GeneralSettingsDateFormatConsole.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsDateFormatConsole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports